import { render, staticRenderFns } from "./MainCreate.vue?vue&type=template&id=26a45b31&scoped=true&"
import script from "./MainCreate.vue?vue&type=script&lang=js&"
export * from "./MainCreate.vue?vue&type=script&lang=js&"
import style0 from "./MainCreate.vue?vue&type=style&index=0&id=26a45b31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a45b31",
  null
  
)

export default component.exports